import { useCallback, useEffect, useState } from "react";

// Reveals completed candles one at a time, left to right, and stops at a fixed
// candle: the decision frame for Call It / Retry, the last candle for Teach.
// Context candles are on screen from the start (they are the reference the
// sequence is read against). Nothing is animated inside a candle: each one
// appears whole.
//
//   shown      how many candles are on screen (from 1)
//   playing    true while candles are still being revealed
//   finished   the stop candle has been reached at least once (stays true
//              through a replay, so an answer chosen at the freeze is kept)
//   replay()   back to the context candles and play again to the stop candle
export default function useSequencePlayer({ context, stopAt, intervalMs, startDelayMs = 350 }) {
  const [shown, setShown] = useState(context);
  const [run, setRun] = useState(0);
  const [finished, setFinished] = useState(false);
  const playing = shown < stopAt;

  useEffect(() => {
    if (shown >= stopAt) {
      setFinished(true);
      return undefined;
    }
    const delay = shown === context ? startDelayMs : intervalMs;
    const t = setTimeout(() => setShown((s) => Math.min(s + 1, stopAt)), delay);
    return () => clearTimeout(t);
  }, [shown, stopAt, context, intervalMs, startDelayMs, run]);

  const replay = useCallback(() => {
    setShown(context);
    setRun((r) => r + 1);
  }, [context]);

  return { shown, playing, finished, replay };
}
